import React from 'react'
import PropTypes from 'prop-types'
import Range from '../Atoms/Range'
import Label from '../Atoms/Label'
import {desaturate, lighten} from 'polished'
import {i18n} from '../../../Utils'
import styled from 'styled-components'
import Hint from '../Atoms/Hint'
import ThinTitle from '../Atoms/ThinTitle'
import SVG from '../Atoms/SVG'

const PasswordLengthRange = ({value, onChange, passwordStrengthString, labelColor, rangeColor, level, icon, onInfoClick}) => {
    return (
        <Wrapper>
            <ThinTitle color={labelColor} margin={'0 0 10px 0'}>
                {i18n('form.range.title.safety_level', {}, true)}
            </ThinTitle>
            <Label
                htmlFor={'password-length-range-input'}
                color={rangeColor}>
                {i18n('form.range.label.number_of_character', {character: value})}
                <Hint color={rangeColor}>
                    {level}
                </Hint>
            </Label>
            <RangeWrapper>
                <Range
                    id={'password-length-range-input'}
                    sliderColor={desaturate(0.1, lighten(0.25, rangeColor))}
                    trackColor={rangeColor}
                    min={4}
                    max={64}
                    step={1}
                    value={value}
                    onChange={onChange}/>
            </RangeWrapper>
            <PasswordSafetyDiv color={rangeColor}>
                <IconWrapper>
                    <SVG color={rangeColor} icon={icon}/>
                </IconWrapper>
                {i18n('form.range.hint.password_strength', {time: passwordStrengthString})}
                <Info onClick={onInfoClick}>
                    <SVG icon={'info'}/>
                </Info>
            </PasswordSafetyDiv>
        </Wrapper>
    )
}

PasswordLengthRange.propTypes = {
    passwordStrengthString: PropTypes.string.isRequired, // As we want to display the time that's needed to hack the password the result of getPasswordStrength here
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    level: PropTypes.string,
    rangeColor: PropTypes.string,
    onInfoClick: PropTypes.func,
}

export default PasswordLengthRange

const Wrapper = styled.div`
    padding: 8px 0;
`

const Info = styled.span`
    display: inline-block;
    height: 22px;
    width: 18px;
    position: relative;
    svg {
        height: 14px;
        cursor: pointer;
        font-size: 12px;
        transition: transform .5s ease;
        display: inline-block;
        top: 2px;
        margin-left: 5px;
        position: absolute;
        ${props => props.active && 'transform: rotate(90deg);'}
    }
`

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    .SVGInline {
        width: 13px;
        display: inline-block;
        height: 19px;
        margin: 0 4px;
    }
`

const RangeWrapper = styled.div`
    margin: 10px 0 5px 0;
`

const PasswordSafetyDiv = styled.div`
    font-size: 12px;
    display: flex;
    color: ${props => props.color ? props.color : 'black'};
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Molecules/PasswordLengthRange.jsx